import Constant from '@/constants.js';

const canAccess = (roles) => {
    let user = JSON.parse(localStorage.getItem(Constant.KeyLocStoreUserIdentity))
    if(user && user.role != undefined){
        return roles.includes(user.role)
    }
    return false
}

const getUser = () => {
    let user = JSON.parse(localStorage.getItem(Constant.KeyLocStoreUserIdentity))
    if(user && user.role != undefined){
        return user
    }
    return {}
}

const isSameDate = (dateStr) => {
  const inputDate = new Date(dateStr);
  const today = new Date();

  return (
    inputDate.getFullYear() === today.getFullYear() &&
    inputDate.getMonth() === today.getMonth() &&
    inputDate.getDate() === today.getDate()
  );
}


const common = {
    canAccess,
    getUser,
    isSameDate
}

export default common